import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
var _class;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import cx from 'classnames';
import { observer } from 'mobx-react';
import styles from './WorkspaceSelector.m.sass';
import ContentLoading from '../../../components/ContentLoading';
import ContentError from '../../../components/ContentError';
import { BodyClass } from '../../../components/ClassName';
import Icon from '../../../components/Icon';
import { Form, Input } from '../../../components/Form';
import Button from '../../../components/Button';
import { extractMessageFromError } from '../../../utils/errorUtil';
var WorkspaceSelector = observer(_class = /*#__PURE__*/function (_React$Component) {
  function WorkspaceSelector() {
    var _this;
    _classCallCheck(this, WorkspaceSelector);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, WorkspaceSelector, [].concat(args));
    _this.selectWorkspace = function (workspace) {
      return _this.props.rootStore.workspaceSelectorStore.selectWorkspace(workspace);
    };
    _this.renderView = function () {
      var store = _this.props.rootStore.workspaceSelectorStore;
      return store.selectWorkspace.match({
        pending: function pending() {
          return /*#__PURE__*/React.createElement(ContentLoading, null);
        },
        rejected: function rejected(err) {
          return _this.renderErrorView({
            err: err
          });
        },
        resolved: function resolved() {
          switch (store.view) {
            case 'selector':
              return _this.renderSelectorView();
            case 'search':
              return _this.renderSearchView();
            case 'profile':
              return _this.renderProfileView();
          }
        }
      });
    };
    _this.renderSearchView = function () {
      var store = _this.props.rootStore.workspaceSelectorStore;
      return /*#__PURE__*/React.createElement(CardContent, {
        store: store
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.searchView
      }, /*#__PURE__*/React.createElement(ViewTitle, {
        subtext: "Please enter your Workspace Name to continue"
      }, "Workspace Domain"), /*#__PURE__*/React.createElement(WorkspaceSearch, {
        store: store
      })));
    };
    _this.renderProfileView = function () {
      var store = _this.props.rootStore.workspaceSelectorStore;
      return /*#__PURE__*/React.createElement(CardContent, {
        store: store
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.profileView
      }, /*#__PURE__*/React.createElement(ViewTitle, {
        subtext: "Tell us about yourself"
      }, "Welcome to ".concat(store.workspace.name)), /*#__PURE__*/React.createElement(ProfileEditor, {
        store: store
      })));
    };
    _this.renderSelectorView = function () {
      var store = _this.props.rootStore.workspaceSelectorStore;
      return /*#__PURE__*/React.createElement(CardContent, {
        store: store
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.selectorView
      }, /*#__PURE__*/React.createElement(ViewTitle, {
        subtext: "Please select a Workspace from the list below"
      }, "Workspace Select"), store.selectWorkspace.match({
        pending: function pending() {
          return /*#__PURE__*/React.createElement(ContentLoading, {
            small: true
          });
        },
        rejected: function rejected(err) {
          return /*#__PURE__*/React.createElement(ContentError, {
            error: err
          });
        },
        resolved: function resolved() {
          return /*#__PURE__*/React.createElement("div", {
            className: styles.memberships
          }, _this.renderSelector(store));
        }
      })));
    };
    _this.renderErrorView = function (_ref13) {
      var err = _ref13.err;
      var store = _this.props.rootStore.workspaceSelectorStore;
      return /*#__PURE__*/React.createElement(CardContent, {
        store: store,
        error: err
      }, /*#__PURE__*/React.createElement(ContentError, {
        error: err
      }), /*#__PURE__*/React.createElement(BackButton, {
        onClick: store.dismissError
      }, "Back to Selector"));
    };
    _this.renderSelector = function (store) {
      var length = store.memberships.length;
      return /*#__PURE__*/React.createElement("div", {
        className: styles.selector
      }, length > 5 && /*#__PURE__*/React.createElement(Input, {
        className: cx(styles.workspaceInput, styles.selectorInput),
        model: store,
        field: "searchText",
        placeholder: "Filter workspaces...",
        iconLeft: "search"
      }), store.filteredMemberships.sort(function (a, b) {
        return a.workspace.name.localeCompare(b.workspace.name);
      }).map(function (_ref14) {
        var member = _ref14.member,
          workspace = _ref14.workspace;
        return /*#__PURE__*/React.createElement(WorkspaceMembership, {
          key: workspace.id,
          workspace: workspace,
          member: member,
          onClick: function onClick() {
            return _this.selectWorkspace(workspace);
          }
        });
      }));
    };
    return _this;
  }
  _inherits(WorkspaceSelector, _React$Component);
  return _createClass(WorkspaceSelector, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.rootStore.workspaceSelectorStore.activate(this.props.invitationToken);
    }
  }, {
    key: "render",
    value: function render() {
      var rootStore = this.props.rootStore;
      var store = rootStore.workspaceSelectorStore;
      return /*#__PURE__*/React.createElement("div", {
        className: cx(styles.root)
      }, /*#__PURE__*/React.createElement(BodyClass, {
        className: styles.body
      }), /*#__PURE__*/React.createElement(CardView, null, store.activate.match({
        pending: function pending() {
          return /*#__PURE__*/React.createElement(ContentLoading, null);
        },
        rejected: function rejected(err) {
          return /*#__PURE__*/React.createElement(ContentError, {
            error: err
          });
        },
        resolved: this.renderView
      })), /*#__PURE__*/React.createElement(ImageView, null));
    }
  }]);
}(React.Component)) || _class;
export { WorkspaceSelector as default };
var CardView = function CardView(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.cardView
  }, children);
};
var ImageView = function ImageView() {
  return /*#__PURE__*/React.createElement("div", {
    className: styles.imageView
  }, /*#__PURE__*/React.createElement("img", {
    src: require('./signup-graphic.svg')
  }));
};
var ButtonSwitch = observer(function ButtonSwitch(_ref2) {
  var store = _ref2.store;
  switch (store.view) {
    case 'selector':
      return /*#__PURE__*/React.createElement("div", {
        className: styles.buttonContainer
      }, store.canCloseSelector && /*#__PURE__*/React.createElement(BackButton, {
        onClick: function onClick() {
          return store.closeSelector();
        }
      }, "Back to App"), /*#__PURE__*/React.createElement(JoinButton, {
        onClick: function onClick() {
          return store.showWorkspaceSearch();
        }
      }, "Join Another Workspace"));
    case 'search':
      return store.memberships.length > 0 && /*#__PURE__*/React.createElement(BackButton, {
        onClick: function onClick() {
          return store.showSelector();
        }
      }, "Back to Selector");
    case 'profile':
      return !store.domainMatchedWorkspace && store.canGoBack && /*#__PURE__*/React.createElement(BackButton, {
        onClick: function onClick() {
          return store.showWorkspaceSearch();
        }
      }, "Back to Search");
  }
});
var CardContent = observer(function CardContent(_ref3) {
  var store = _ref3.store,
    children = _ref3.children,
    error = _ref3.error;
  var workspace = window.__workspaceDomain && window.__workspaceDomain.workspace || {
    branding: {
      logos: {},
      colors: {}
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: styles.cardContent
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.cardItem
  }, /*#__PURE__*/React.createElement("img", {
    alt: "Worklayer",
    src: workspace.branding.logos.primary || require('./worklayer-logo.svg')
  })), children, !error && /*#__PURE__*/React.createElement("div", {
    className: styles.cardItem
  }, /*#__PURE__*/React.createElement(ButtonSwitch, {
    store: store
  })));
});
var WorkspaceMembership = observer(function WorkspaceMembership(_ref4) {
  var workspace = _ref4.workspace,
    member = _ref4.member,
    onClick = _ref4.onClick;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.workspace,
    onClick: onClick
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.logoContainer
  }, /*#__PURE__*/React.createElement("img", {
    className: styles.logo,
    src: workspace.branding.logos.icon,
    alt: workspace.name
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.workspaceInfo
  }, /*#__PURE__*/React.createElement("p", {
    className: styles.workspaceTitle
  }, workspace.name), /*#__PURE__*/React.createElement("p", {
    className: styles.workspaceSubtitle
  }, workspace.domains && workspace.domains.length > 0 ? workspace.domains[0].domain : "".concat(workspace.slug, ".worklayer.com"))), /*#__PURE__*/React.createElement("div", {
    className: styles.iconContainer
  }, /*#__PURE__*/React.createElement(Icon, {
    className: styles.icon,
    small: true,
    material: true,
    name: "arrow forward ios"
  })));
});
var ViewTitle = function ViewTitle(_ref5) {
  var subtext = _ref5.subtext,
    children = _ref5.children;
  return /*#__PURE__*/React.createElement("p", {
    className: styles.heading
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.headingBig
  }, children), /*#__PURE__*/React.createElement("span", {
    className: styles.headingSmall
  }, subtext));
};
var ProfileEditor = observer(function ProfileEditor(_ref6) {
  var _store$workspace, _workspaceConfig$publ, _workspaceConfig$exte;
  var store = _ref6.store;
  var workspaceConfig = ((_store$workspace = store.workspace) === null || _store$workspace === void 0 ? void 0 : _store$workspace.config) || {};
  var magicLinkEnabled = ((_workspaceConfig$publ = workspaceConfig.public_api_config) === null || _workspaceConfig$publ === void 0 ? void 0 : _workspaceConfig$publ.signed_url_enabled) && ((_workspaceConfig$exte = workspaceConfig.external_customers_config) === null || _workspaceConfig$exte === void 0 ? void 0 : _workspaceConfig$exte.enabled);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.profileEditor
  }, /*#__PURE__*/React.createElement(Form, {
    onSubmit: function onSubmit() {
      return store.createMember();
    }
  }, /*#__PURE__*/React.createElement(ErrorInfo, {
    error: store.createMember.error
  }), /*#__PURE__*/React.createElement(Input, {
    autoFocus: true,
    className: cx(styles.workspaceInput, styles.profileInput),
    model: store,
    field: "givenName",
    label: "First name",
    placeholder: "e.g. Joe"
  }), /*#__PURE__*/React.createElement(Input, {
    className: cx(styles.workspaceInput, styles.profileInput),
    model: store,
    field: "familyName",
    label: "Last name",
    placeholder: "e.g. Schmoe"
  }), /*#__PURE__*/React.createElement(Input, {
    className: cx(styles.workspaceInput, styles.profileInput),
    model: store,
    field: "email",
    label: "Email address",
    disabled: magicLinkEnabled,
    placeholder: "e.g. joe@schmoe.com"
  }), /*#__PURE__*/React.createElement(Input, {
    className: cx(styles.workspaceInput, styles.profileInput),
    model: store,
    field: "phone",
    label: "Phone",
    placeholder: "e.g. 305-555-6666"
  }), /*#__PURE__*/React.createElement(CallToAction, {
    view: store.view,
    loading: store.createMember.pending,
    icon: /*#__PURE__*/React.createElement(Icon, {
      material: true,
      name: "check"
    }),
    submit: true
  }, "Complete Registration")));
});
var DomainError = observer(function DomainError(_ref7) {
  var store = _ref7.store,
    children = _ref7.children;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.domainError + store.domainCheck()
  }, children);
});
var WorkspaceSearch = observer(function WorkspaceSearch(_ref8) {
  var store = _ref8.store;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.searchBox
  }, /*#__PURE__*/React.createElement(Form, {
    onSubmit: function onSubmit() {
      return store.selectWorkspace(store.workspace);
    }
  }, /*#__PURE__*/React.createElement(Input, {
    autoFocus: true,
    className: cx(styles.workspaceInput, styles.searchInput, store.domainCheck()),
    model: store,
    field: "domain",
    placeholder: "your-workspace-url"
  }), /*#__PURE__*/React.createElement(DomainError, {
    store: store
  }, "This workspace does not exist. Try again."), /*#__PURE__*/React.createElement(CallToAction, {
    view: store.view,
    icon: /*#__PURE__*/React.createElement(Icon, {
      material: true,
      name: "arrow forward ios"
    }),
    submit: true
  }, "Continue")));
});
var CallToAction = function CallToAction(_ref9) {
  var submit = _ref9.submit,
    loading = _ref9.loading,
    children = _ref9.children,
    onClick = _ref9.onClick,
    view = _ref9.view,
    icon = _ref9.icon;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.callToActionContainer
  }, /*#__PURE__*/React.createElement(Button, {
    className: styles.callToActionButton,
    submit: submit,
    type: "primary",
    size: "big",
    shadow: true,
    iconRight: view === 'profile' ? icon : null,
    iconFarRight: view === 'search' ? icon : null,
    loading: loading,
    disabled: loading
  }, children));
};
var BackButton = function BackButton(_ref10) {
  var _onClick = _ref10.onClick,
    children = _ref10.children;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.backButtonContainer
  }, /*#__PURE__*/React.createElement(Button, {
    className: styles.backButton,
    outline: true,
    borderless: true,
    type: "primary",
    iconLeft: /*#__PURE__*/React.createElement(Icon, {
      material: true,
      name: "arrow back"
    }),
    onClick: function onClick(e) {
      return e.preventDefault() || _onClick(e);
    }
  }, children));
};
var JoinButton = function JoinButton(_ref11) {
  var _onClick2 = _ref11.onClick,
    children = _ref11.children;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.joinButtonContainer
  }, /*#__PURE__*/React.createElement(Button, {
    className: styles.joinButton,
    outline: true,
    borderless: true,
    type: "primary",
    iconRight: /*#__PURE__*/React.createElement(Icon, {
      material: true,
      name: "arrow forward"
    }),
    onClick: function onClick(e) {
      return e.preventDefault() || _onClick2(e);
    }
  }, children));
};
var ErrorInfo = function ErrorInfo(_ref12) {
  var error = _ref12.error;
  return !error ? null : /*#__PURE__*/React.createElement("div", {
    className: styles.errorInfo
  }, extractMessageFromError(error));
};
//# sourceMappingURL=index.js.map
